<template>
  <div />
</template>
<script>

/**
 * Vue: Hero carousel (hero-carousel)
 * -----------------------------------------------------------------------------
 * A full-bleed image carousel with supporting content.
 *
 * @param {Array} slides - A list of slides with image and content.
 *
 */
import heroCarousel from '~/components/hero-carousel'

export default {
  name: 'HeroCarousel',

  mounted() {
    heroCarousel().init()
  },
}
</script>

<style lang="scss">
@import './hero-carousel';
</style>
